import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

import { api } from "@/lib/api";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const m = useMutation({
    mutationFn: (e: string) =>
      api<{ status: string; debug_link?: string | null }>("/portal/auth/request", {
        method: "POST",
        body: JSON.stringify({ email: e }),
      }),
    onSuccess: () => setSent(true),
  });

  return (
    <div className="mx-auto max-w-md space-y-4 rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
      <h1 className="text-2xl font-semibold">Sign in</h1>
      <p className="text-sm text-slate-600">
        Enter your email and we'll send a link that signs you in. The link
        expires in 30 minutes and can only be used once.
      </p>
      {sent ? (
        <div className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-900">
          Check your email — we just sent a link to <strong>{email}</strong>.
          {m.data?.debug_link ? (
            <div className="mt-2 break-all text-xs text-slate-600">
              Dev link: <a className="underline" href={m.data.debug_link}>{m.data.debug_link}</a>
            </div>
          ) : null}
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (email.trim()) m.mutate(email.trim());
          }}
          className="space-y-3"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
            required
          />
          <button
            type="submit"
            disabled={!email.trim() || m.isPending}
            className="w-full rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-500 disabled:opacity-50"
          >
            {m.isPending ? "Sending…" : "Send sign-in link"}
          </button>
          {m.isError ? (
            <div className="text-xs text-red-600">{(m.error as Error).message}</div>
          ) : null}
        </form>
      )}
    </div>
  );
}
